// src/components/AceiteAtivo.jsx
// Caixa de aceite ATIVO (orientação do advogado, 13/10/2026): o usuário precisa marcar para concordar com os Termos de
// Uso e a Política de Privacidade e consentir com o tratamento dos dados — inclusive na compra do Entry sem cadastro.
// VERSAO_TERMOS identifica qual texto estava publicado quando a pessoa aceitou (trocar quando os textos mudarem).
import React from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../services/firebase';

export const VERSAO_TERMOS = 'termos-2026-10-13';

// Guarda a prova do aceite no servidor. Best effort: falha de rede não impede a pessoa de seguir (só registra no console).
export async function registrarAceite(contexto, planoId) {
  try {
    const chamar = httpsCallable(getFunctions(app, 'southamerica-east1'), 'registrarAceite');
    await chamar({ versao: VERSAO_TERMOS, contexto, planoId: planoId || null });
  } catch (e) {
    console.error('[PHOENIX] Não foi possível registrar o aceite (seguindo):', e);
  }
}

export default function AceiteAtivo({ checked, onChange, name, required = false, comReembolso = false, className = '' }) {
  const props = {};
  if (typeof checked === 'boolean') props.checked = checked;
  if (typeof onChange === 'function') props.onChange = (e) => onChange(e.target.checked);
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none text-left ${className}`}>
      <input
        type="checkbox"
        name={name}
        required={required}
        className="mt-0.5 w-4 h-4 shrink-0 accent-lime-400"
        {...props}
      />
      <span className="text-[11px] text-slate-400 leading-relaxed">
        Li e concordo com os <a href="/termos-de-uso" target="_blank" rel="noopener noreferrer" className="underline text-slate-200">Termos de Uso</a> e
        a <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer" className="underline text-slate-200">Política de Privacidade</a> e
        consinto com o tratamento dos meus dados pessoais.
        {comReembolso && (
          <> Sei que posso desistir em até 7 dias, conforme a <a href="/reembolso" target="_blank" rel="noopener noreferrer" className="underline text-slate-200">política de reembolso</a>.</>
        )}
      </span>
    </label>
  );
}
